export default function SpecialOfferBanner() {
  return (
    <section className="py-5 bg-brand-purple">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 bg-white/20 rounded-full">
            <i className="ri-price-tag-3-line text-white text-xl"></i>
          </div>
          <div>
            <p className="text-white font-700 text-lg" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700 }}>
              20% OFF your first order!
            </p>
            <p className="text-white/80 text-sm">Use code: <strong className="text-white">LITTLELOOP20</strong> at checkout</p>
          </div>
        </div>
        <div className="flex items-center gap-4 text-white/80 text-sm">
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-5 h-5">
              <i className="ri-time-line text-white text-base"></i>
            </div>
            <span>Limited time offer</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-5 h-5">
              <i className="ri-star-line text-white text-base"></i>
            </div>
            <span>New customers only</span>
          </div>
        </div>
      </div>
    </section>
  );
}